<script>
import {  common } from '@/mixins/common';
import { PostApiWithAuthorizationAction } from '../../../helpers/apiActions';

export default {
  name: 'ReturnOrderItemDialog',
  components: {},
  props: {
    displayDialog: {
      type: Boolean,
      required: true
    },
    reasons: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    productId: {
      type: Number,
      required: true,
      default() {
        return 0
      }
    },
    orderId: {
      type: Number,
      required: true,
      default() {
        return 0
      }
    },
  },
  data() {
    return {
      error: '',
      form: {
        reason: '',
        custom_reason: ''
      },
      rules: {
        reason: [
          { required: true, message: 'Reason field is required.', trigger: 'change' },
        ]
      },
      disabled: false
    }
  },
  mixins: [
    common
  ],
  methods: {
    handleDialogClose() {
      this.$root.$emit('close-dialog', 'displayReturnOrderItemDialog')
    },
    submit() {
      let _vm = this
      _vm.disabled = true
      _vm.$refs.formContainer.validate((valid) => {
        if (valid) {
          PostApiWithAuthorizationAction("admin/orders/return-order-item", {
            ... _vm.form,
            auctionId: _vm.productId,
            orderId: _vm.orderId
          })
          .then(res => {
            if (res.status == 'success') {
              _vm.$root.$emit('close-order-item-dialog')
              if (res.totalRemainingItems == 0) {
                _vm.$root.$emit('remove-order', _vm.orderId)
              } else {
                _vm.$root.$emit('remove-order-item', {
                    orderId : _vm.orderId,
                    auctionId: _vm.productId
                })
              }
              _vm.form.reason = ''
              _vm.error = ''
              //
              _vm.$toast.success(res.message, {
                    position: "top-right",
                    timeout: 3000,
                    closeOnClick: true
                });
            } else {
              _vm.error = res.message
            }
          }).finally(() => {
            _vm.disabled = false
          });
        } else {
            _vm.disabled = false
        }
      });
    },
  },
  watch: {
    'reasons': function() {
      this.form.reason = ''
    }
  }
}
</script>

<template>
    <el-dialog
      custom-class="el-dialog-bs-info"
      :visible.sync="displayDialog"
      width="30%"
      @close="handleDialogClose">
      <span slot="title"><h5><i class="fas fa-undo"></i> Return Item</h5></span>
      <el-form
        :model="form"
        @submit.native.prevent="submit"
        ref="formContainer"
        id="returnOrderItemForm">
        <div class="mb-1 font-weight-bold font-size-16 text-center">
            Reason Of Return:
        </div>
        <div class="mb-0 text-center">
            <el-form-item label="" class="mb-0">
                <el-select
                    v-model="form.reason"
                    placeholder="Select a reason"
                    style="width: 100%">
                    <el-option
                        v-for="it in reasons"
                        :key="it.id"
                        :label="it.reason"
                        :value="it.reason">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label=""
                v-show="form.reason == 'Other'">
                <el-input
                    type="textarea"
                    v-model="form.custom_reason"
                    placeholder="Type custom reason..."
                    :autosize="{ minRows: 3 }"></el-input>
            </el-form-item>
        </div>
        <div class="mb-2">
          <el-form-item
            :rules="rules.reason"
            prop="reason">
            <div class="el-form-item__error">{{ error }}</div>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer text-right">
        <el-button
          @click="submit()"
          type="danger"
          :disabled="disabled">PROCEED</el-button>
      </span>
    </el-dialog>
</template>